import { useUploadContextFactory } from '../upload-contexts/use-upload-context-factory';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';

const ResultRow = ({ email, message, className }) => (
  <TableRow className={`cursor-default pointer-events-none ${className}`}>
    <TableCell className="border border-solid border-slate-300">{email}</TableCell>
    <TableCell className="border border-solid border-slate-300">{message}</TableCell>
  </TableRow>
);

const ShowResults = ({ contextType }) => {
  const { results } = useUploadContextFactory({ contextType });
  const { new: newUsers = [], updated = [], failed = [] } = results;

  return (
    <Table>
      <TableHeader>
        <div className="flex gap-1 font-medium mb-2">
          <p>Total created: {newUsers.length},</p>
          <p>Total updated: {updated.length},</p>
          <p>Total failed: {failed.length}</p>
        </div>
        <TableRow>
          <TableHead className="border border-solid border-slate-300">Email</TableHead>
          <TableHead className="border border-solid border-slate-300">Result</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {newUsers.map(({ email, message }) => (
          <ResultRow key={email} email={email} message={message} className="bg-green-400" />
        ))}
        {updated.map(({ email, message }) => (
          <ResultRow key={email} email={email} message={message} className="bg-yellow-400" />
        ))}
        {failed.map(({ email, message }) => (
          <ResultRow key={email} email={email} message={message} className="bg-red-400" />
        ))}
      </TableBody>
    </Table>
  );
};

export default ShowResults;
